export default {
  'Choose File': 'Dosya seçin',
  'Please paste a URL': 'Lütfen bir URL yapıştırın',
  'Loading': 'Yükleniyor',
  'Analyzing': 'Analiz',
  'Try a sample': 'Bir örnek deneyin',
  'Sorry, error occurs when analyzing the URL.': 'Maalesef, URL analiz edilirken hata oluşuyor.',
  'Upload a photo': 'Bir fotoğraf yükle',
  "Drag and drop files to the upload box.": 'Dosyaları yükleme kutusuna sürükleyip bırakın.',
  'Please select the proper position with portrait.': 'Lütfen portre ile uygun pozisyonu seçin.',
  'downloading': 'İndiriliyor',

}